<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Transactions Report for Today",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      data: {
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        category: "",
        title: "Transactions Report for Today",
      },
      title: "Transactions Report",
      items: [
        {
          text: "Transactions Report",
          href: "/",
        },
        {
          text: "Transactions Report",
          active: true,
        },
      ],
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      totalRows: 1,
      total_amount_in: 0,
      total_amount_out: 0,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsGetTransactionsServerPaginated: true,
      serverPerPage: 50,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "category",
          sortable: true,
          label: "CATEGORY",
        },
        {
          key: "amount_in",
          sortable: true,
          label: "AMOUNT IN",
        },
        {
          key: "amount_out",
          sortable: true,
          label: "AMOUNT OUT",
        },
        {
          key: "mode",
          sortable: true,
          label: "PAYMENT MODE",
        },
        {
          key: "description",
          sortable: true,
          label: "DESCRIPTION",
        },
        {
          key: "recordedon",
          sortable: true,
          label: "DATE/TIME",
        },
        {
          key: "recordedby",
          sortable: true,
          label: "RECORDED BY",
        },
      ],
      options: [
        { value: "1", label: "Sales" },
        { value: "2", label: "Expenses" },
        { value: "3", label: "Purchases" },
        { value: "4", label: "Sales Returns" },
        { value: "5", label: "Purchase Returns" },
        { value: "6", label: "CashOut" },
        { value: "7", label: "CashIn" },
        { value: "8", label: "Money Transfer" },
        { value: "9", label: "Customer Deposits" },
      ],
      json_fields: {
        CATEGORY: "category",
        AMOUNT_IN: "amount_out",
        AMOUNT_OUT: "amount_out",
        MODE: "mode",
        DESCRIPTION: "description",
        DATE_TIME: "recordedon",
        RECORDED_BY: "recordedby",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("accounts", [
      "GetTransactions",
      "SaveStatus",
      "GetTransactionsPagination",
      "GetTransactionsPaginated",
      "GetTransactionsSummary",
    ]),
    ...mapGetters("products", ["Products"]),
    ...mapGetters("auth", ["business", "branch"]),

    rows() {
      return this.IsGetTransactionsServerPaginated
        ? this.GetTransactionsPagination.total
        : this.GetTransactions
        ? this.GetTransactions.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsGetTransactionsServerPaginated) {
          return (
            this.GetTransactionsPagination.per_page ||
            this.data.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsGetTransactionsServerPaginated) {
          this.data.per_page = value;
          this.data.page = 1;
          this.FetchTransactions(this.data);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.GetTransactionsPaginated && this.GetTransactionsPagination
          ? this.GetTransactionsPagination.current_page
          : 1;
      },
      set(value) {
        if (this.GetTransactionsPaginated) {
          this.data.page = value;
          this.handlePageChange(value);
        }
      },
    },

    totals() {
      return (
        this.GetTransactionsSummary || {
          total_amount_in: 0,
          total_amount_out: 0,
        }
      );
    },
  },

  methods: {
    ...mapActions({
      FetchTransactions: "accounts/fetchTransactions",
    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m === "" || m === undefined || m === null) {
        return m;
      }
      const str = m.toString();
      const integerPart = str.split(".")[0];
      return integerPart
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    SetData() {
      this.FetchTransactions(this.data);
      if (this.data.category != "") {
        let cat = "";
        if (this.data.category == 1) {
          cat = "Sales";
        } else if (this.data.category == 2) {
          cat = "Expenses";
        } else if (this.data.category == 3) {
          cat = "Purchases";
        } else if (this.data.category == 4) {
          cat = "Sales returns";
        } else if (this.data.category == 5) {
          cat = "Purchases returns";
        } else if (this.data.category == 6) {
          cat = "Cashout";
        } else if (this.data.category == 7) {
          cat = "Cashin";
        } else if (this.data.category == 8) {
          cat = "Money transfers";
        } else if (this.data.category == 9) {
          cat = "Customer deposits";
        }
        this.data.title =
          "Transactions Report for " +
          cat +
          " From " +
          this.data.datefrom +
          " To " +
          this.data.dateto;
      } else {
        this.data.title =
          "Transactions Report From " +
          this.data.datefrom +
          " To " +
          this.data.dateto;
      }
    },

    handlePageChange(newPage) {
      if (this.IsGetTransactionsServerPaginated) {
        this.data.page = newPage;
        this.FetchTransactions(this.data);
      }
    },
  },

  created() {
    this.FetchTransactions(this.data);
  },
};
</script>

<template>
  <Layout>
    <h4 class="text-center text-primary" v-if="business && branch">
      {{ business }} - {{ branch }}
    </h4>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3
                  class="card-title mb-2 text-center"
                  v-html="data.title"
                ></h3>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                <download-excel
                  class="btn btn-info"
                  :data="GetTransactions"
                  :fields="json_fields"
                  :worksheet="'TRANSACTIONS REPORT FOR' + currentdate"
                  type="csv"
                  :name="'Transactions_report' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
              </div>
              <div class="col-md-3 form-group mb-2">
                <label>FROM</label>
                <input
                  type="date"
                  v-model="data.datefrom"
                  class="form-control"
                />
              </div>
              <div class="col-md-3 form-group">
                <label>TO</label>
                <input v-model="data.dateto" type="date" class="form-control" />
              </div>
              <div class="col-md-2 form-group">
                <label>CATEGORIES</label>

                <model-list-select
                  :list="
                    options ? [{ id: '', name: 'All Options' }, ...options] : []
                  "
                  v-model="data.category"
                  option-value="value"
                  option-text="label"
                  placeholder="Select Category"
                  @input="SetData()"
                >
                </model-list-select>
              </div>
              <div class="col-md-1 mt-4">
                <button
                  class="btn btn-primary cursor-pointer"
                  type="button"
                  @click="SetData()"
                >
                  <span class="fa fa-filter cursor-pointer"></span> Filter
                  <b-spinner
                    v-show="SaveStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
             
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                responsive="sm"
                :columns="fields"
                :rows="GetTransactions"
                :total-rows="rows"
                :pagination="GetTransactionsPagination"
                :server-pagination="IsGetTransactionsServerPaginated"
                :loading="SaveStatus"
              >
                <template #cell(index)="{ index }">
                  {{ (currentPage - 1) * perPage + index + 1 }}
                </template>
                <template #cell(category)="{ row }">
                  {{ row.category }}
                </template>
                <template #cell(amount_in)="{ row }">
                  {{ thousandSeperator(row.amount_in) }}
                </template>
                <template #cell(amount_out)="{ row }">
                  {{ thousandSeperator(row.amount_out) }}
                </template>
                <template #cell(mode)="{ row }">
                  {{ row.mode }}
                </template>
                <template #cell(description)="{ row }">
                  {{ row.description }}
                </template>
                <template #cell(recordedon)="{ row }">
                  {{ row.recordedon }}
                </template>
                <template #cell(recordedby)="{ row }">
                  {{ row.recordedby }}
                </template>
              </DataTable>
              <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-4">
                  <h5>Total Amount In: <span class="text-danger">{{thousandSeperator(totals.total_amount_in)}}</span></h5>
                </div>
                <div class="col-md-2"></div>
                <div class="col-md-4">
                  <h5>Total Amount Out: <span class="text-danger">{{thousandSeperator(totals.total_amount_out)}}</span></h5>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
